import { Box, Popover, PopoverTrigger } from '@chakra-ui/react';
import React from 'react';
import useTypewriter from '../../../hooks/useTypewriter';
import AiAssistBorder from './AiAssistBorder';
import AiAssistPopoverContent from './AiAssistPopoverContent';
import AiAssistButton from './AiAssistButton';
import { localise } from '../../../services/lang/lang';
import { AiFeedbackContext } from '../../../types/enums/AiFeedbackContext';
import { RenderIf } from '../RenderIf/RenderIf';
const AiAssistSummary = ({ handlePopoverOpened, openedIndex, summary, model, title, footer, }) => {
    const isOpen = openedIndex === model.id;
    const { text, isWriting } = useTypewriter(summary, isOpen);
    return (React.createElement(Popover, { isOpen: isOpen, onClose: () => handlePopoverOpened(model.id), onOpen: () => handlePopoverOpened(model.id), placement: "right-start", closeOnBlur: false },
        React.createElement(AiAssistBorder, null,
            React.createElement(PopoverTrigger, null,
                React.createElement(Box, null,
                    React.createElement(AiAssistButton, { shouldShowTooltip: !isOpen, isWorking: isWriting, label: localise('SUMMARISE_TENANT_REPORT_LABEL') })))),
        React.createElement(RenderIf, { condition: isOpen },
            React.createElement(AiAssistPopoverContent, { model: model, context: AiFeedbackContext.SUMMARY, title: title, text: text, footer: footer }))));
};
export default AiAssistSummary;
